module.exports = __webpack_public_path__ + "img/IMG_20191125_201205.4a1e572d.jpg";